import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=0462aa86"
import script from "./Assign.vue?vue&type=script&lang=js"
export * from "./Assign.vue?vue&type=script&lang=js"
import style0 from "./Assign.vue?vue&type=style&index=0&id=0462aa86&prod&lang=css"
import style1 from "./Assign.vue?vue&type=style&index=1&id=0462aa86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports